import React, { useState, useContext, useEffect } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { List, ListItem, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import * as actions from '../actions/actions';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Service from "../services/service";
import LaunchIcon from '@material-ui/icons/Launch'; 
import ShareIcon from '@material-ui/icons/Share';
import { IconButton } from '@material-ui/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
        flexDirection: "column",
        display: "flex",
        overflowY: "auto",
        padding: 0,
        width: '100%'
    },
    date_format: {
        padding: "0 !important",
    },
    action_block: {
        textAlign: "center",
        paddingBottom: "10px",
        margin: '0 16px',
        display: 'none'
    },
    text_filed_container: {
        width: '100%'
    },
    button_block: {
        width: '100%',
        display: 'none'
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    sourceIconContainer: {
        display: "flex",
        lineHeight: "revert",
        alignItems: "center"
    },
    formGroupPadding: {
        width: "fit-content",
        display: "flex",
        flexDirection: "unset",
    },
    noMargin: {
        margin: "0"
    }
}));

export default function ProjectUploadForm(props) {
    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const { project } = props;

    const [propertyData, setPropertyData] = useState({
        date: project && project.Date ? project.Date : new Date(),
        name: project && project.Name ? project.Name : '',
        description: project && project.Description ? project.Description : '',
        uploadformactive: project && project.UploadFormActive && (project.UploadFormActive === true || project.UploadFormActive === '1') ? true : false,
        uploadformheader: project && project.UploadFormHeader  ? project.UploadFormHeader : '',
        uploadformdescription: project && project.UploadFormDescription ? project.UploadFormDescription : '',
    });

    useEffect(() => {
        resetProject();
    }, [JSON.stringify(project)]);

    const resetProject = () => {
      setPropertyData({
        ...propertyData,
        date: project && project.Date ? project.Date : new Date(),
        name: project && project.Name ? project.Name : '',
        description: project && project.Description ? project.Description : '',
        uploadformactive: project && project.UploadFormActive && project.UploadFormActive ? true : false,
        uploadformheader: project && project.UploadFormHeader  ? project.UploadFormHeader : '',
        uploadformdescription: project && project.UploadFormDescription ? project.UploadFormDescription : '',
      });
    }

    const handlesourceCheckbox = (value) => {
        dispatch(actions.set_project_data(value));
        Service.UpdateProject({ ...propertyData, uploadformactive: value ? '1' : '0' }, project.Id).then(res => {
          if (res.success) {
              dispatch(actions.notifyProjectsChanged());
              if (res.message === 'notificationMessage.projectUpdated') {
                  dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectUpdated, status: true }));
              }
          } else {
            dispatch(actions.openToast({ type: "false", message: res.errors[0], status: true }));
          }
        });
    };

    const handleSubmit = (e, type) => {
      e.preventDefault();
      if (!project.Id) {
        dispatch(actions.setDraftProject(propertyData));
        return;
      }
        setPropertyData({
            ...propertyData,
            uploadformheader: propertyData.uploadformheader.trim(),
            uploadformdescription: propertyData.uploadformdescription.trim()
        });
        if (type === 'uploadformheader' && !project.UploadFormHeader && !propertyData.uploadformheader.trim()) {
            return false;
        }
        if (type === 'uploadformheader' && project.UploadFormHeader === propertyData.uploadformheader.trim()) {
            return false;
        }
        if (type === 'uploadformdescription' && !project.UploadFormDescription && !propertyData.uploadformdescription.trim()) {
            return false;
        }
        if (type === 'uploadformdescription' && project.UploadFormDescription === propertyData.uploadformdescription.trim()) {
            return false;
        }
        onConfirmUpdate();
    }

    const launch = () => {
        let url = (window.location.href).replace('projects', 'upload');
        window.open(url + "/" + project.UploadFormLink, "_blank")
    }

    const share = () => {
        let url = (window.location.href).replace('projects', 'upload');
        navigator.clipboard.writeText(url + '/' + project.UploadFormLink);
        dispatch(actions.openToast({ type: "success", message: s.copiedToClipboard, status: true }));
    }

    const onConfirmUpdate = (key) => {
        let sendData = { ...propertyData }
        sendData['uploadformactive'] = propertyData.uploadformactive ? '1' : '0';
      Service.UpdateProject(sendData, project.Id).then(res => {
        if (res.success) {
            dispatch(actions.notifyProjectsChanged());
            if (res.message === 'notificationMessage.projectUpdated') {
                dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectUpdated, status: true }));
            }
        } else {
          dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
        }
      });
    }

    return (
        <div className={classes.root}>
            <form className={classes.form} noValidate autoComplete="off">
                <FormGroup className={classes.formGroupPadding} >
                    <FormControlLabel
                        className={classes.noMargin}
                        control={<Switch checked={propertyData.uploadformactive} onChange={(e) => handlesourceCheckbox(e.target.checked)} />}
                        label={<span className={classes.sourceIconContainer}>
                            {s.useUpload}
                        </span>} />
                        <IconButton onClick={() => { launch() }} disabled={!propertyData.uploadformactive}>
                            <LaunchIcon />
                        </IconButton>
                        <CopyToClipboard text={(window.location.href).replace('projects', 'upload') + "/" + project.UploadFormLink}>
                            <IconButton disabled={!propertyData.uploadformactive}>
                                <ShareIcon />
                            </IconButton>
                        </CopyToClipboard>
                </FormGroup>
                <List>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                className={classes.text_filed_container}
                                label={s.uploadFormHeading}
                                size="small"
                                disabled={!propertyData.uploadformactive}
                                value={propertyData.uploadformheader}
                                InputProps={{ endAdornment: "" }}
                                onBlur={(e) => handleSubmit(e, 'uploadformheader')}
                                onChange={(evt) =>
                                    setPropertyData({ ...propertyData, uploadformheader: evt.target.value })
                                }
                            />
                        </div>
                    </ListItem>
                    <ListItem>
                        <div className={classes.text_filed_container}>
                            <TextField
                                multiline
                                className={classes.text_filed_container}
                                size="small"
                                disabled={!propertyData.uploadformactive}
                                label={s.uploadFormText}
                                value={propertyData.uploadformdescription || ""}
                                onBlur={(e) => handleSubmit(e, 'uploadformdescription')}
                                onChange={(evt) =>
                                    setPropertyData({ ...propertyData, uploadformdescription: evt.target.value })
                                }
                            />
                        </div>
                    </ListItem>
                </List>
                <Button className={classes.button_block} type="submit">
                    {s.submit}
                </Button>
            </form>
        </div>
    );
};
